/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { ExutoireDto } from '../models/exutoire-dto';
import { LoadResult } from '../models/load-result';
import { TransporteurOrExutoireOrDispatchDto } from '../models/transporteur-or-exutoire-or-dispatch-dto';


/**
 * Fonctions de gestion des exutoires
 */
@Injectable({
  providedIn: 'root',
})
export class ExutoiresService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation exutoireGetList
   */
  static readonly ExutoireGetListPath = '/api/exutoires/list';

  /**
   * Renvoie la liste des exutoires.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exutoireGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  exutoireGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ExutoireDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ExutoiresService.ExutoireGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExutoireDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des exutoires.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exutoireGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exutoireGetList(params?: {
  }): Observable<Array<ExutoireDto>> {

    return this.exutoireGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ExutoireDto>>) => r.body as Array<ExutoireDto>)
    );
  }

  /**
   * Path part for operation exutoireGetListActifs
   */
  static readonly ExutoireGetListActifsPath = '/api/exutoires/list-actifs';

  /**
   * Renvoie la liste des exutoires actifs et des dispatchs associés.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exutoireGetListActifs()` instead.
   *
   * This method doesn't expect any request body.
   */
  exutoireGetListActifs$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TransporteurOrExutoireOrDispatchDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ExutoiresService.ExutoireGetListActifsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TransporteurOrExutoireOrDispatchDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des exutoires actifs et des dispatchs associés.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exutoireGetListActifs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exutoireGetListActifs(params?: {
  }): Observable<Array<TransporteurOrExutoireOrDispatchDto>> {

    return this.exutoireGetListActifs$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TransporteurOrExutoireOrDispatchDto>>) => r.body as Array<TransporteurOrExutoireOrDispatchDto>)
    );
  }

  /**
   * Path part for operation exutoireLoadList
   */
  static readonly ExutoireLoadListPath = '/api/exutoires/load-list';

  /**
   * Renvoie la liste des exutoires (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exutoireLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exutoireLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ExutoiresService.ExutoireLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des exutoires (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exutoireLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exutoireLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.exutoireLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation exutoireGet
   */
  static readonly ExutoireGetPath = '/api/exutoires/{id}';

  /**
   * Renvoie l'exutoire spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exutoireGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  exutoireGet$Response(params: {

    /**
     * Identifiant de l&#x27;exutoire
     */
    id: number;
  }): Observable<StrictHttpResponse<ExutoireDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExutoiresService.ExutoireGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExutoireDto>;
      })
    );
  }

  /**
   * Renvoie l'exutoire spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exutoireGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exutoireGet(params: {

    /**
     * Identifiant de l&#x27;exutoire
     */
    id: number;
  }): Observable<ExutoireDto> {

    return this.exutoireGet$Response(params).pipe(
      map((r: StrictHttpResponse<ExutoireDto>) => r.body as ExutoireDto)
    );
  }

  /**
   * Path part for operation exutoirePut
   */
  static readonly ExutoirePutPath = '/api/exutoires/{id}';

  /**
   * Met à jour l'exutoire spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exutoirePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exutoirePut$Response(params: {

    /**
     * Identifiant de l&#x27;exutoire à mettre à jour
     */
    id: number;

    /**
     * Exutoire
     */
    body: ExutoireDto
  }): Observable<StrictHttpResponse<ExutoireDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExutoiresService.ExutoirePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExutoireDto>;
      })
    );
  }

  /**
   * Met à jour l'exutoire spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exutoirePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exutoirePut(params: {

    /**
     * Identifiant de l&#x27;exutoire à mettre à jour
     */
    id: number;

    /**
     * Exutoire
     */
    body: ExutoireDto
  }): Observable<ExutoireDto> {

    return this.exutoirePut$Response(params).pipe(
      map((r: StrictHttpResponse<ExutoireDto>) => r.body as ExutoireDto)
    );
  }

  /**
   * Path part for operation exutoireDelete
   */
  static readonly ExutoireDeletePath = '/api/exutoires/{id}';

  /**
   * Supprime l'exutoire spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exutoireDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  exutoireDelete$Response(params: {

    /**
     * Identifiant de l&#x27;exutoire à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ExutoiresService.ExutoireDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'exutoire spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exutoireDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exutoireDelete(params: {

    /**
     * Identifiant de l&#x27;exutoire à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.exutoireDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation exutoirePost
   */
  static readonly ExutoirePostPath = '/api/exutoires';

  /**
   * Crée l'exutoire spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exutoirePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exutoirePost$Response(params: {

    /**
     * Exutoire
     */
    body: ExutoireDto
  }): Observable<StrictHttpResponse<ExutoireDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExutoiresService.ExutoirePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExutoireDto>;
      })
    );
  }

  /**
   * Crée l'exutoire spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exutoirePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exutoirePost(params: {

    /**
     * Exutoire
     */
    body: ExutoireDto
  }): Observable<ExutoireDto> {

    return this.exutoirePost$Response(params).pipe(
      map((r: StrictHttpResponse<ExutoireDto>) => r.body as ExutoireDto)
    );
  }

  /**
   * Path part for operation exutoireDesactivate
   */
  static readonly ExutoireDesactivatePath = '/api/exutoires/{id}/desactivate';

  /**
   * Désactive l'exutoire spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exutoireDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exutoireDesactivate$Response(params: {

    /**
     * Identifiant de l&#x27;exutoire à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ExutoireDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ExutoiresService.ExutoireDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive l'exutoire spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exutoireDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exutoireDesactivate(params: {

    /**
     * Identifiant de l&#x27;exutoire à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ExutoireDto
  }): Observable<number> {

    return this.exutoireDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation exutoireGetByReference
   */
  static readonly ExutoireGetByReferencePath = '/api/exutoires/reference/{reference}';

  /**
   * Renvoie l'exutoire recherché par référence.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exutoireGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  exutoireGetByReference$Response(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<StrictHttpResponse<ExutoireDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExutoiresService.ExutoireGetByReferencePath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExutoireDto>;
      })
    );
  }

  /**
   * Renvoie l'exutoire recherché par référence.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exutoireGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exutoireGetByReference(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<ExutoireDto> {

    return this.exutoireGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<ExutoireDto>) => r.body as ExutoireDto)
    );
  }

}
